var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 8.375C9.25 8.16789 9.08211 8 8.875 8H3.5C2.395 8 1.5 7.105 1.5 6C1.5 4.895 2.395 4 3.5 4H9.75C10.0815 4 10.3995 4.1317 10.6339 4.36612C10.8683 4.60054 11 4.91848 11 5.25C11 5.58152 10.8683 5.89946 10.6339 6.13388C10.3995 6.3683 10.0815 6.5 9.75 6.5H4.5C4.225 6.5 4 6.275 4 6C4 5.725 4.225 5.5 4.5 5.5H8.875C9.08211 5.5 9.25 5.33211 9.25 5.125V5.125C9.25 4.91789 9.08211 4.75 8.875 4.75H4.5C4.16848 4.75 3.85054 4.8817 3.61612 5.11612C3.3817 5.35054 3.25 5.66848 3.25 6C3.25 6.33152 3.3817 6.64946 3.61612 6.88388C3.85054 7.1183 4.16848 7.25 4.5 7.25H9.75C10.855 7.25 11.75 6.355 11.75 5.25C11.75 4.145 10.855 3.25 9.75 3.25H3.5C1.98 3.25 0.75 4.48 0.75 6C0.75 7.52 1.98 8.75 3.5 8.75H8.875C9.08211 8.75 9.25 8.58211 9.25 8.375V8.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipe);
export default __webpack_public_path__ + "static/media/IconClipe.e56f47a20aa384c5ce364f683368b702.svg";
export { ForwardRef as ReactComponent };